import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './components/App/App';
import './index.scss';
import registerServiceWorker from './registerServiceWorker';
import { createBrowserHistory } from 'history';
import configureStore from './configureStore';
import { addInterceptor } from './utils/axiosHelper';
import { checkAuth } from './utils/authHelper';

export const history = createBrowserHistory();

export const store = configureStore(history);

export const url = 'https://anmeldung.region-villach.at';

// export const url = 'http://localhost:8000';

// export const url = (() => {
//   console.log(process.env.NODE_ENV);
//   if (process.env.NODE_ENV === 'development') {
//     console.log('IN DEV MODE');
//     return 'http://localhost:8000';
//     // return 'http://10.0.0.29:8000';
//     // return 'http://192.168.188.22:8000';
//   } else {
//     console.log('IN PROD MODE');
//     return 'http://anmeldung-dev.region-villach.at';
//   }
// })();

export const apiUrl = '/api';

addInterceptor(url);
checkAuth(store.dispatch);

ReactDOM.render(<App store={store} history={history} />, document.getElementById(
  'root'
) as HTMLElement);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx